import React, { useEffect } from 'react';
import { TrackingClient } from '@sparefoot/tracking-client';
import { useSelector } from 'react-redux';

// Selector function to get meta title
const getPageMetaTitle = (state) =>
	state.pageMeta?.tags?.title || 'Default Title';

/**
 * Custom hook for page view tracking.
 * @param {string|Function} page - Page type or function that returns page type from props
 */
export const usePageViewTracking = (page, props = {}) => {
	const pageTitle = useSelector((state) => getPageMetaTitle(state));

	useEffect(() => {
		if (typeof window !== 'undefined') {
			const pageType = typeof page === 'function' ? page(props) : page;
			TrackingClient.trackPageView({
				page_name: pageTitle,
				page_type: pageType,
			});
		}
	}, []); // eslint-disable-line react-hooks/exhaustive-deps
};

/**
 * HOC wrapper for page view tracking (backward compatible).
 * Uses useSelector hook for Redux state.
 */
function withPageViewTracking(page) {
	return (WrappedComponent) => {
		const WithPageViewTracking = (props) => {
			const pageTitle = useSelector((state) => getPageMetaTitle(state));

			useEffect(() => {
				if (typeof window !== 'undefined') {
					const pageType =
						typeof page === 'function' ? page(props) : page;
					TrackingClient.trackPageView({
						page_name: pageTitle,
						page_type: pageType,
					});
				}
			}, []); // eslint-disable-line react-hooks/exhaustive-deps
			return <WrappedComponent {...props} />;
		};
		WithPageViewTracking.displayName = `withPageViewTracking(${WrappedComponent.displayName || WrappedComponent.name || 'Component'})`;
		return WithPageViewTracking;
	};
}

export default withPageViewTracking;
